import { render } from "./PCMenu.vue?vue&type=template&id=1ec8f03a&scoped=true"
import script from "./PCMenu.vue?vue&type=script&lang=js"
export * from "./PCMenu.vue?vue&type=script&lang=js"

import "./PCMenu.vue?vue&type=style&index=0&id=1ec8f03a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec8f03a"]])

export default __exports__